import {
   Component, ElementRef, OnInit, Renderer2, ViewChild,
   ComponentRef, ComponentFactoryResolver, ViewContainerRef, HostListener, NgZone, OnDestroy
} from '@angular/core';
import {SignOffComponent} from '../../sign-off/sign-off.component';
import { MatLegacyButton as MatButton } from '@angular/material/legacy-button';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import {IdexService} from 'app/idex.service';
import {Toast} from 'app/shared/toast/toast';
import {RegisterSignatureComponent} from 'app/e-signature/register-signature/register-signature.component';
import {TranslateService} from '@ngx-translate/core';
import {TwofactorComponent} from '../../../account/twofactor/twofactor.component';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {Mimetype} from 'app/shared/mimetype';
import {PdfRenditionWatcher} from 'app/shared/pdf-rendition-watcher';
import {DocTypeComponent} from '../../../shared/doctype.component';
import {MomentPipe} from 'app/shared/moment.pipe';
import {DeleteCommentComponent} from '../../../dms/delete-comment/delete-comment.component';
import {DomSanitizer} from '@angular/platform-browser';
import {ThumbnailComponent} from '../thumbnail/thumbnail.component';
import { TaskAttribute } from '../../create-task/create-task.type';

declare let $: any;

export interface ImageData {
   itemImgThumbnail: ItemImageThumbnail[];
   lastPageLoaded: number;
}

export interface ItemImageThumbnail {
   docId: string;
   pageNo: number;
   isLoad: boolean;
}

@Component({
   selector: 'app-sign-dialog',
   templateUrl: './sign-dialog.component.html',
   styleUrls: ['./sign-dialog.component.css']
})
export class SignDialogComponent implements OnInit, OnDestroy {

   doc;
   show: boolean;
   item: any;
   settype = false;
   types: any[];
   saveText = 'Save';
   form: any;
   lastModified: any;
   comment: any;
   post = 'ส่ง';
   isSender: boolean;
   shiftPressed = false;
   flagCheckSelect = false;
   public selectedValue: any;
   private componentRef1: ComponentRef<{}>;
   private componentRef2: ComponentRef<{}>;
   @ViewChild('form1', {read: ViewContainerRef}) form1: ViewContainerRef;
   @ViewChild('form2', {read: ViewContainerRef}) form2: ViewContainerRef;
   public taskAttribute: TaskAttribute = {
      taskId: 0,
      taskName: '',
      dueDate: null,
      priority: 0,
      templateId: 0,
      workflowId: 0,
      currentLevel: 1,
      apvLevel: [],
      docList: [],
      message: ''
   };
   public selectButton = false;
   public docId;
   public tempId;
   public totalPages: any;
   public checkselectedItems: any = [];
   public imgThumbnails: ImageData[] = [];
   private thumbnailWatcher = new PdfRenditionWatcher();
   public thumbnailSelected = [];
   public selectDelItems: any[] = [];
   public dataWidthHeight: any;
   public dataWidthHeightAll: any;
   public maxIndex = -1;
   public isThumbnailLoadFinish = false;
   public docName: any;
   public email: any;
   public sender: any;
   public getDoc = [];
   @ViewChild(SignOffComponent, { static: true }) public signOffComp: SignOffComponent;
   @ViewChild(ThumbnailComponent, { static: true }) public thumbnailComp: ThumbnailComponent;
   @ViewChild('info') info: ElementRef;
   @ViewChild('tools') tools: ElementRef;
   private dpi = 20;
   private registerSignDialog: MatDialogRef<RegisterSignatureComponent>;
   private twofactor: MatDialogRef<TwofactorComponent>;
   private _keyFieldType = {
      signature: 'signature',
      initSignature: 'initSignature',
      name: 'name',
      date: 'date'
   };
   private giveScrollThumbnails: number;
   public isToggleLeftOpened = true;
   public isToggleRightOpened = true;
   public typeNames: string;

   constructor(private actRoute: ActivatedRoute,
               private router: Router,
               public service: IdexService,
               private toast: Toast,
               private dialog: MatDialog,
               private translate: TranslateService,
               private renderer: Renderer2,
               private sanitizer: DomSanitizer,
               private resolver: ComponentFactoryResolver,
               private zone: NgZone) {
      this.actRoute.params.forEach((params: Params) => {
         this.getDoc = [];
         this.docId = params['doc-id'];
         if (params['temp-id']) {
            this.tempId = atob(params['temp-id']);
         } else {
            this.tempId = null;
         }
         this.getDoc.push(this.docId);
         this.getThumbnail(this.getDoc);
         this.getDocument();
         this.getComment();
      });
      this.translate.get('send').subscribe(s => {
         this.post = s;
      });
   }

   ngOnInit() {
      this.signOffComp.typeName = 'sign';
   }

   /**
    * get document info for menu right side
    */
   getDocument(): void {
      this.service.getDocument(this.docId)
         .subscribe((data: any) => {
               this.doc = data;
               this.email = this.service.user.email;
               this.sender = this.doc.creator.id;
               this.isSender = this.email === this.sender;
               this.taskAttribute.docList.push({docName: data.name, docId: this.docId});
               this.docName = data.name;
               this.show = Mimetype.canEdit(this.doc);
               const fmt = new MomentPipe();
               this.lastModified = {when: fmt.transform(this.doc.modified)};
               if (!data.typeName) {
                  this.service.getTypes().subscribe(dataType => {
                     this.types = dataType;
                  });
                  this.settype = false;
               } else {
                  this.settype = true;
                  setTimeout(() => {
                     if (this.doc.properties) {
                        this.componentRef1 = DocTypeComponent.create(this.resolver, this.componentRef1, this.form1, this.doc.properties);
                     }
                  }, 200);
               }
            },
            (error: any) => {
               // This is intentional.
            });
   }

   /**
    * Get Thumbnails data
    */
   ngOnDestroy() {
      this.thumbnailWatcher.release(ids => this.service.releasePdfTransform(ids));
   }

   getThumbnail(docList) {
      this.service.transformPdfThumbnails(docList, this.dpi, undefined, true).subscribe((data) => {
         // ไฟล์ยังแปลงไม่เสร็จ: โหลด thumbnail ใหม่เมื่อพร้อม
         this.thumbnailWatcher.watch(data, ids => this.service.transformPdfThumbnails(ids, this.dpi, undefined, true),
            () => this.getThumbnail(docList));
         this.imgThumbnails = [];
         this.dataWidthHeight = data[0].pages;
         this.dataWidthHeightAll = data[0].pages;
         this.totalPages = data[0].totalPages;
         const itemImgThumbnail = [];
         for (let i = 0; i < data[0].totalPages; i++) {
            itemImgThumbnail.push({
               docId: data[0].docId,
               pageNo: i + 1,
               isLoad: false,
            });
            this.checkselectedItems[i] = false;
         }
         this.imgThumbnails.push({
            itemImgThumbnail: itemImgThumbnail,
            lastPageLoaded: 0
         });
         if (this.imgThumbnails[0].itemImgThumbnail.length <= 4) {
            this.setInitialLoadThumbnail(this.imgThumbnails[0].itemImgThumbnail.length, 0);
         } else {
            this.setInitialLoadThumbnail(5, 0);
         }
         this.isThumbnailLoadFinish = true;
      }, (err) => {
         this.isThumbnailLoadFinish = true;
         this.handleWaitAction(false);
         console.error(err);
      });
   }

   /**
    * call back when listclick in signpage
    */
   onListClick($event): void {
      if (this.signOffComp._dataPages !== undefined && this.signOffComp._dataPages.length > 0) {
         this.setInitialThumbnail();
      }
   }

   back() {
      const path = localStorage.getItem('url');
      const search = '/search';
      if (this.tempId) {
         this.service.deleteDocument(this.tempId).subscribe(() => {});
      }
      let param;
      if (path.startsWith(search)) {
         param = path.substring(path.indexOf('=') + 1);
         this.router.navigate([search], {queryParams: {q: param}});
         return;
      }
      this.zone.run(() => {
         this.router.navigate([localStorage.getItem('url')]);
      });
      localStorage.removeItem('url');
   }

   /**
    * Toggle Menu
    */
   toggleRight(): void {
      if (this.info) {
         if (this.info.nativeElement.className.indexOf('slide-right') === -1) {
            this.renderer.addClass(this.info.nativeElement, 'slide-right');
            this.isToggleRightOpened = false;
            if (!this.signOffComp.isZoom && this.signOffComp._isVisible !== 'visible') {
               this.signOffComp.handleFitPage(true);
            }
            if (this.isToggleLeftOpened) {
               this.signOffComp.setHeaderWidth(this.checkWidth('T1'));
            } else {
               this.signOffComp.setHeaderWidth(this.checkWidth('T2'));
            }
         } else {
            this.renderer.removeClass(this.info.nativeElement, 'slide-right');
            this.isToggleRightOpened = true;
            if (!this.signOffComp.isZoom && this.signOffComp._isVisible !== 'visible') {
               this.signOffComp.handleFitPage(false);
            }
            if (this.isToggleLeftOpened) {
               this.signOffComp.setHeaderWidth(this.checkWidth('T3'));
            } else {
               this.signOffComp.setHeaderWidth(this.checkWidth('T4'));
            }
         }
      }
   }

   toggleLeft(): void {
      this.signOffComp.drawer.toggle(this.signOffComp.navChange(this, this.signOffComp.drawer));
      this.isToggleLeftOpened = this.signOffComp.drawer.opened;
      if (this.isToggleLeftOpened) {
         if (this.isToggleRightOpened) {
            this.signOffComp.setHeaderWidth(this.checkWidth('T3'));
         } else {
            this.signOffComp.setHeaderWidth(this.checkWidth('T1'));
         }
      } else {
         if (this.isToggleRightOpened) {
            this.signOffComp.setHeaderWidth(this.checkWidth('T4'));
         } else {
            this.signOffComp.setHeaderWidth(this.checkWidth('T2'));
         }
      }
   }

   /**
    * CheckWidth device for responsive
    */
   checkWidth(size) {
      if (size === 'T1' || size === 'T3') {
         return 250;
      } else  {
         return 0;
      }
   }

   setDocName(name) {
      this.docName = name;
   }

   handleWaitAction(isShow) {
      if (isShow) {
         $('#pano-sign-off').show();
         $('#main-sign-off').addClass('blur');
      } else {
         $('#pano-sign-off').hide();
         $('#main-sign-off').removeClass('blur');
      }
   }

   /**
    * Callback warppage to page do you want
    */
   wrapPage(pageNo) {
      this.signOffComp.warpPage(pageNo);
   }

   saveDescription(e: Event): void {
      const input = <HTMLTextAreaElement>e.target;
      if (input.value !== this.doc.description) {
         // TODO: call PUT /description { id: this.doc.id, description: input.value }
         this.doc.description = input.value;
         this.service.updateDescription(input.value, this.docId)
            .subscribe(
               data => {
                  // This is intentional.
               },
               error => {
                  // This is intentional.
               });
      }
   }

   saveProperties(button: MatButton) {
      const properties = this.getProperties(this.doc.properties);
      if (!properties) {
         return;
      }
      button.disabled = true;
      this.saveText = 'Saving...';
      this.service.setMetadata(this.doc.id, properties).subscribe(data => {
         this.doc.properties = data;
         this.saveText = 'Saved';
         setTimeout(() => {
            button.disabled = false;
            this.saveText = 'Save';
         }, 5000);
      });
   }

   loadForm(option: any) {
      this.selectedValue = option;
      this.form = undefined;
      this.service.getType(option.value).subscribe(data => {
            this.form = data;
            this.componentRef2 = DocTypeComponent.create(this.resolver, this.componentRef2, this.form2, data);
         },
         (err) => {
            console.error(err);
         });
   }

   onScrollTum(page) {
      if (this.isToggleRightOpened) {
         if (this.thumbnailComp) {
            this.thumbnailComp.scroll(page);
         }
      }
   }

   private getProperties(form: any[]) {
      const error = function (e, msg) {
         e.focus();
         return null;
      };
      const properties = {};
      for (let i = 0; i < form.length; i++) {
         const f = form[i];
         const e = $('#' + f.name.replace(':', '_'));
         const value = e.val();
         if (f.mandatory && !value) {
            return error(e, f.label + ' is required');
         }
         if (f.constraints && value) {
            if (f.constraints.minLength && value.length < f.constraints.minLength) {
               return error(e, 'Minimum length of ' + f.label + ' is ' + f.constraints.minLength + ' characters');
            }
            if (f.constraints.maxLength && value.length > f.constraints.maxLength) {
               return error(e, 'Maximum length of ' + f.label + ' is ' + f.constraints.maxLength + ' characters');
            }
            if (f.constraints.minValue !== undefined && value < f.constraints.minValue) {
               return error(e, 'Minimum value of ' + f.label + ' is ' + f.constraints.minValue);
            }
            if (f.constraints.maxValue !== undefined && value > f.constraints.maxValue) {
               return error(e, 'Maximum value of ' + f.label + ' is ' + f.constraints.maxValue);
            }
            if (f.constraints.expression && !new RegExp(f.constraints.expression).test(value)) {
               return error(e, 'Value of ' + f.label + ' did not match the pattern');
            }
         }
         properties[f.name] = value;
      }
      return properties;
   }

   saveType(button: any) {
      const data = {type: this.selectedValue.value, properties: this.getProperties(this.form)};
      if (!data.properties) {
         return;
      }
      button.disabled = true;
      this.translate.get('saving').subscribe(s => {
         this.saveText = s;
      });
      this.service.setType(this.doc.id, data).subscribe(value => {
         this.doc.typeName = this.selectedValue.viewValue;
         this.doc.properties = value;
         setTimeout(() => {
            this.componentRef1 = DocTypeComponent.create(this.resolver, this.componentRef1, this.form1, this.doc.properties);
         }, 200);
         this.translate.get('saved').subscribe(s => {
            this.saveText = s;
         });
         setTimeout(() => {
            button.disabled = false;
            this.translate.get('save').subscribe(s => {
               this.saveText = s;
            });
         }, 5000);
      });
   }

   /**
    * set data comment
    */
   getComment(): void {
      this.service.getComment(this.docId).subscribe(
         data => {
            this.comment = data.items;
         });
   }

   postComment(button: MatButton, input: any): void {
      const text = input.value.trim();
      if (text.length === 0) {
         input.focus();
         return;
      }
      button.disabled = true;
      this.translate.get('sending').subscribe(s => {
         this.post = s;
      });
      this.service.postComment(this.docId, text, this.taskAttribute.taskId).subscribe(
         () => {
            input.value = '';
            this.translate.get('sended').subscribe(s => {
               this.post = s;
            });
            this.getComment();
            setTimeout(() => {
               button.disabled = false;
               this.translate.get('send').subscribe(s => {
                  this.post = s;
               });
            }, 3000);
         },
         error => {
            button.disabled = false;
            this.translate.get('send').subscribe(s => {
               this.post = s;
            });
         });
   }

   delComment(item: any): void {
      const dialogRef = this.dialog.open(DeleteCommentComponent, {
         disableClose: true,
         data: {service: this.service, item: item}
      });
      dialogRef.afterClosed().subscribe(result => {
         if (result) {
            const i = this.comment.indexOf(item);
            if (i !== -1) {
               this.comment.splice(i, 1);
            }
         }
      });
   }

   editComment(item: any) {
      item.editing = true;
      setTimeout(() => {
         $('#edit-' + item.id).focus();
      }, 200);
   }

   saveComment(item: any, input: any) {
      if (input.value.trim().length === 0) {
         return;
      }
      let url;
      if (this.taskAttribute.taskId) {
         url = '/comments/' + item.id + '/' + this.docId + '?taskId=' + this.taskAttribute.taskId;
      } else {
         url = '/comments/' + item.id + '/' + this.docId;
      }
      this.service.put(url, {content: encodeURIComponent(input.value)})
         .subscribe(res => {
            item.editing = false;
            item.content = input.value;
         });
   }

   transform(value) {
      return this.sanitizer.bypassSecurityTrustHtml(value);
   }

   @HostListener('document:keydown', ['$event'])
   onKeyDown(e: KeyboardEvent) {
      if (e.shiftKey) {
         this.shiftPressed = true;
      } else if (e.key === 'a' && (e.ctrlKey || e.metaKey)) {
         e.preventDefault();
         e.stopPropagation();
         $('.textarea_detail').select();
      }
   }

   @HostListener('document:keyup', ['$event'])
   onKeyUp(e: KeyboardEvent) {
      if (e.shiftKey) {
         this.shiftPressed = false;
      }
   }

   /**
    * handle when scroll in sign page
    */
   onScrollThumbnails(event) {
      const lastPageLoaded = this.imgThumbnails[this.signOffComp.currentIndex].lastPageLoaded;
      const scrollTop = $(event.target)[0].scrollTop;
      const heightBody = $(event.target)[0].clientHeight;
      const heightChild = $($(event.target)[0]).children()[0].clientHeight;
      const heightChildAll = heightChild * lastPageLoaded;
      if (Math.ceil((heightBody + scrollTop)) >= heightChildAll) {
         if (this.imgThumbnails[this.signOffComp.currentIndex].itemImgThumbnail.length > lastPageLoaded) {
            this.imgThumbnails[this.signOffComp.currentIndex].itemImgThumbnail[lastPageLoaded].isLoad = true;
            this.imgThumbnails[this.signOffComp.currentIndex].lastPageLoaded++;
         }
      }
   }

   setInitialThumbnail() {
      const index = this.signOffComp.currentIndex;
      if (this.imgThumbnails.length > 0) {
         if (this.imgThumbnails[index].itemImgThumbnail !== undefined && this.imgThumbnails[index].itemImgThumbnail.length > 0) {
            this.imgThumbnails[index].itemImgThumbnail = this.imgThumbnails[index].itemImgThumbnail.map((item) => ({
                  ...item,
                  isLoad: false,
               })
            );
         }
      }
      if (this.imgThumbnails[index].itemImgThumbnail.length < 3) {
         for (let count = 0; count < this.imgThumbnails[index].itemImgThumbnail.length; count++) {
            this.imgThumbnails[index].itemImgThumbnail[count].isLoad = true;
            this.imgThumbnails[index].lastPageLoaded = count;
         }
      } else {
         this.imgThumbnails[index].itemImgThumbnail[0].isLoad = true;
         this.imgThumbnails[index].itemImgThumbnail[1].isLoad = true;
         this.imgThumbnails[index].itemImgThumbnail[2].isLoad = true;
         this.imgThumbnails[index].lastPageLoaded = 3;
      }
   }

   setInitialLoadThumbnail(num, index) {
      for (let count = 0; count < num; count++) {
         this.imgThumbnails[index].itemImgThumbnail[count].isLoad = true;
      }
      this.imgThumbnails[index].lastPageLoaded = num;
   }
}
